// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
      	suggestionMobileStyle: 'style2',
	}
};

(function() {
	BoostPFS.inject(this);

    var localeParams = Api.setApiLocaleParams;
	Api.setApiLocaleParams = function(params) {
      var params = localeParams(params);

      if (Utils.isSearchPage() || params.event_type === "suggest") {
        Globals.defaultSorting = 'manual';
      }
      
      return params;
    }
    
	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
  
    InstantSearchApi.afterCallAsync = function(result, callbackInstantSearchApi) {
        /* Call 3rd party api */
        if (typeof window.Locksmith === 'object') {
        var URLs = []
        var URLsCollection = []
        var totalUrls = []
        var grantedAccess = []
        var grantedAccessCollection = []
        //Create an array of products URLs
        for(var i = 0; i < result.products.length; i ++){
            URLs.push('/products/' + result.products[i].handle);
        }
        for(var i = 0; i < result.collections.length; i ++){
            URLsCollection.push('/collections/' + result.collections[i].handle);
        }
        totalUrls = URLs.concat(URLsCollection)
        jQ.ajax({
            method: 'GET',
            url: '/apps/locksmith/api/resources',
            data: { urls: totalUrls,},
            timeout: 1500,
        async: false,
            success: function(response) {
                var resources = JSON.parse(response);
                for(var i = 0; i < URLs.length; i ++){
                    //Checks that the response exists
                    if(resources[URLs[i]]){
                    //Checks that the access of the product has been granted
                    if(resources[URLs[i]].access_granted || resources[URLs[i]].manual_lock){
                        //If the product is accesible add it to the array of the products
                        grantedAccess.push(result.products[i])
                    }
                    }
                }
                //Change array of products
                result.products = grantedAccess;
                //Same for collections
                for(var i = 0; i < URLsCollection.length; i ++){
                    //Checks that the response exists
                    if(resources[URLsCollection[i]]){
                    //Checks that the access of the product has been granted
                    if(resources[URLsCollection[i]].access_granted || resources[URLsCollection[i]].manual_lock){
                        //If the product is accesible add it to the array of the products
                        grantedAccessCollection.push(result.collections[i])
                    }
                    }
                }
                //Change array of collections
                result.collections = grantedAccessCollection;
                /* Build everything after getting instant search data */
                callbackInstantSearchApi(result);
            },
            error: function() {
                /* Build everything after getting instant search data */
                callbackInstantSearchApi(result);
            },
        });
        } else {
            callbackInstantSearchApi(result);
        }
    }
})();


